import {
    FETCH_ALL_CONFIGURATION_DATA,
    FETCH_CONFIGURATION_DATA,
    SET_ACTIVE_CONFIGURATION,
    SET_IS_FROM_RULES_GRID,
    SET_IGNORE_DEFAULT_CONFIGURATION,
    SET_IS_CLEAR_APPLIED_CONFIGURATION,
    SET_CONFIGURATION_DATA,
    SET_REDIRECTION,
    SHOW_CONFIGURATION_ICON,
    SHOW_SAVE_CONFIGURATION_MODAL,
    SHOW_SAVE_AS_CONFIGURATION_MODAL,
    UPDATE_CONFIGURATION_DATA
} from '../actions/actionTypes';

const initialState = {
    activeConfiguration:          {},
    allConfigurations:            [],
    configurations:               [],
    isFromRulesGrid:              false,
    ignoreDefaultConfiguration:   false,
    isClearAppliedConfiguration:  false,
    newConfiguration:             {},
    redirection:                  {},
    showConfigurationIcon:        true,
    showSaveConfigurationModal:   false,
    showSaveAsConfigurationModal: false,
    updateConfigurationData:      false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ALL_CONFIGURATION_DATA:
            return {
                ...state,
                allConfigurations: action.payload
            };
        case FETCH_CONFIGURATION_DATA:
            return {
                ...state,
                configurations: action.payload
            };
        case SET_CONFIGURATION_DATA:
            return {
                ...state,
                newConfiguration: action.payload
            };
        case SET_ACTIVE_CONFIGURATION:
            return {
                ...state,
                activeConfiguration: action.payload
            };
        case SHOW_SAVE_CONFIGURATION_MODAL:
            return {
                ...state,
                showSaveConfigurationModal: action.payload
            };
        case SHOW_SAVE_AS_CONFIGURATION_MODAL:
            return {
                ...state,
                showSaveAsConfigurationModal: action.payload
            };
        case SHOW_CONFIGURATION_ICON:
            return {
                ...state,
                showConfigurationIcon: action.payload
            };
        case UPDATE_CONFIGURATION_DATA:
            return {
                ...state,
                updateConfigurationData: action.payload
            };
        case SET_IS_FROM_RULES_GRID:
            return {
                ...state,
                isFromRulesGrid: action.payload
            };
        case SET_IS_CLEAR_APPLIED_CONFIGURATION:
            return {
                ...state,
                isClearAppliedConfiguration: action.payload
            };
        case SET_REDIRECTION:
            return {
                ...state,
                redirection: action.payload
            };
        case SET_IGNORE_DEFAULT_CONFIGURATION:
            return {
                ...state,
                ignoreDefaultConfiguration: action.payload
            };
        default:
            return state;
    }
};
